/** @format */
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { TransitionService } from '@uirouter/angular';
import { UIRouterGlobals } from '@uirouter/core';
import { EnvironmentService } from 'sis-common';

@Component({
    selector: 'sis-login',
    templateUrl: './login.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
    @Input() mobileMode = false;

    @Output() keydownPressed = new EventEmitter<any>();
    @Output() blurMobileLogin = new EventEmitter<any>();

    loginState: string;
    isActive = false;
    // Explicitly clear loggedOut/reason and disable param inheritance — the user is asking to log in,
    // they shouldn't carry post-logout markers from the URL they happen to be on.
    readonly loginParams = { loggedOut: undefined as undefined, reason: undefined as undefined };
    readonly loginOptions = { inherit: false };

    private deregisterTransitionHook: Function;

    constructor(
        private environmentService: EnvironmentService,
        private transitionService: TransitionService,
        private uiRouterGlobals: UIRouterGlobals,
        private changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loginState = `${this.environmentService.frontendName.toLowerCase()}.login`;
        this.isActive = this.uiRouterGlobals.current.name === this.loginState;
        this.deregisterTransitionHook = this.transitionService.onSuccess({}, transition => {
            this.isActive = transition.to().name === this.loginState;
            this.changeDetectorRef.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.deregisterTransitionHook?.();
    }
}
